import { Injectable } from '@angular/core';

declare let dataLayer: any;

@Injectable()
export class GoogleAnalyticsService {
  // Sends a Google Analytics event when no search results are found
  // Term could be search term, service description or service category
  sendNoSearchResultsEvent(term: string, location: string) {
    if (dataLayer) {
      dataLayer.push({
        event: 'hcf-no-search-results',
        'hcf-term': term,
        'hcf-location': location,
      });
    }
  }
  // Sends a Google Analytics event when search results are found
  sendSearchResultsEvent(term: string, location: string) {
    if (dataLayer) {
      dataLayer.push({
        event: 'hcf-search-results',
        'hcf-term': term,
        'hcf-location': location,
      });
    }
  }

  sendNoAutocompleteResultsEvent(term: string, location: string) {
    if (dataLayer) {
      dataLayer.push({
        event: 'hcf-no-autocomplete',
        'hcf-term': term,
        'hcf-location': location,
      });
    }
  }

  sendNoLocationResultsEvent(term: string, location: string) {
    if (dataLayer) {
      dataLayer.push({
        event: 'hcf-no-location',
        'hcf-term': term,
        'hcf-location': location,
      });
    }
  }

  sendAutocompleteResultsEvent(term: string, location: string) {
    if (dataLayer) {
      dataLayer.push({
        event: 'hcf-autocomplete',
        'hcf-term': term,
        'hcf-location': location,
      });
    }
  }

  sendLocationResultsEvent(term: string, location: string, hcfLocationDetected = false) {
    if (dataLayer) {
      dataLayer.push({
        event: 'hcf-location',
        'hcf-term': term,
        'hcf-location': location,
        'hcf-location-detected': hcfLocationDetected,
      });
    }
  }

  sendPageViewEvent(url: string) {
    if (dataLayer) {
      dataLayer.push({
        event: 'virtualPageView',
        virtualPage: url,
      });
    }
  }
}
